<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-envelope-open-dollar"></i> Payments Received
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <PaymentReceivedDataTable>
          <template v-slot:title>
            <h3>Payments Received List</h3>
          </template>
          <template v-slot:tools>
            <ActionButton type="new" v-if="userHasCreatePermission(PermissionTypes.AccountsPermissionTypes.payment)" @click="addPayment" sizeClass="btn"> Add Payment</ActionButton>            
          </template>
        </PaymentReceivedDataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import PaymentReceivedDataTable from '@/modules/accounts/components/paymentReceivedDataTable'
import AddPaymentDialog from '@/modules/accounts/views/addPaymentDialog'

export default {
  name: 'PaymentReceivedList',
  components: {
    PaymentReceivedDataTable
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    }
  },
  methods: {
    addPayment() {
      this.displayModal(AddPaymentDialog)
      .then(paymentId => {
        if(paymentId) {
          this.successToast('Payment Received')
          this.$router.push(`/accounts/paymentreceiveds/${paymentId}`)
        }
      })
    },
  }
};
</script>
